import { combineReducers } from 'redux';
import { createSelectorHook } from 'react-redux';
import ableReducer from './ableReducer';
import demoReducer from './demoReducer';
import { propertyMasterReducer, PROPERTY_MASTER } from './propertyMaster/propertyMaster.reducer';
import { NAVIGATION, navigationReducer } from './dynamicNavigation/dynamicNavigation.reducer';
import { PROPERTY, propertyReducer } from './property/property.reducer';
import { stateMasterReducer, STATE_MASTER } from './stateMaster/stateMaster.reducer';
import { userHeaderReducer, USER_HEADER } from './userHeader/userHeader.reducer';
import { unitMasterReducer, UNIT_MASTER } from './unitMaster/unitMaster.reducer';
import { menuMasterReducer, MENU_MASTER } from './menuMaster/menuMaster.reducer';
import { AREA_MASTER, companyAreaReducer } from './areaMaster/areaMaster.reducer';
import { companyMasterReducer, COMPANY_MASTER } from './companyMaster/companyMaster.reducer';
import { ROLES, rolesReducer } from './roles/roles.reducer';
import { userDetailsReducer, USER_DETAILS } from './userDetails/userDetails.reducer';
import { colorReducer, COLOR_MASTER } from './colorMaster/colorMaster.reducer';
import { colorDetailsReducer, COLOR_DETAILS } from './colorDetails/colorDetails.reducer';
import { teamMasterReducer, TEAM_MASTER } from './teamMaster/teamMaster.reducer';
import { teamDetailsReducer, TEAM_DETAILS } from './teamDetails/teamDetails.reducer';
import { partyMasterReducer, PARTY_MASTER } from './partyMaster/partyMaster.reducer';
import { partyDetailsReducer, PARTY_DETAILS } from './partyDetails/partyDetails.reducer';
import { EMPLOYEE, employeeReducer } from './employee/employee.reducer';
import { sizeInfoReducer, SIZE_INFO } from './sizeInfo/sizeInfo.reducer';
import { sizeRatioReducer, SIZE_RATIO } from './sizeRatio/sizeRatio.reducer';
import { yearMasterReducer, YEAR_MASTER } from './yearMaster/yearMaster.reducer';
import { seasonMasterReducer, SEASON_MASTER } from './seasonMaster/seasonMaster.reducer';
import { sizeMeasurementReducer, SIZE_MEASUREMENT_MASTER } from './sizeMeasurementMaster/sizeMeasurementMaster.reducer';
import { sizeMeasurementDetailsReducer, SIZE_MEASUREMENT_DETAILS } from './sizeMeasurementDetails/sizeMeasurementDetails.reducer';
import { accessInfoAndDetailsReducer, ACCESS_INFO_AND_DETAILS } from './accessInfoAndDetails/accessInfoAndDetails.reducer';
import { bankMasterReducer, BANK_MASTER } from './bankMaster/bankMaster.reducer';
import { hsnMasterReducer, HSN_MASTER } from './hsnMaster/hsnMaster.reducer';
import { priceMappingReducer, PRICE_MAPPING } from './priceMapping/priceMapping.reducer';
import { accessoriesMasterReducer, ACCESSORIS_MASTER } from './accessoriesMaster/accessoriesMaster.reducer';
import { accessoriesUsageReducer, ACCESSORIES_USAGE } from './accessoriesUsage/accessoriesUsage.reducer';
import { STOCK, stockReducer } from './stock/stock.reducer';
import { commonPropertyReducer, COMMON_PROPERTY } from './property/common/commonProperty.reducer';
import { brandMasterReducer, BRAND_MASTER } from './brandMaster/brandMaster.reducer';
import { productMasterReducer, PRODUCT_MASTER } from './product/product.reducer';
import { productDetailsReducer, PRODUCT_DETAILS } from './productDetails/productDetails.reducer';
import { styleMasterReducer, STYLE_MASTER } from './styleMaster/styleMaster.reducer';
import { feedbacktMasterReducer, FEEDBACK_MASTER } from './feedbackMaster/feedbackMaster.reducer';
import { feedbackDetailsReducer, FEEDBACK_DETAILS } from './feedbackDetails/feedbackDetails.reducer';
import { defaultStyleMasterReducer, DEFAULT_STYLE_MASTER } from './defaultStyleMaster/defaultStyleMaster.reducer';
import { styleDetailReducer, STYLE_DETAIL } from './styleDetail/styleDetail.reducer';
import { programMappingReducer, PROGRAM_MAPPING } from './programMapping/programMapping.reducer';
import { programConstraintReducer, PROGRAM_CONSTRAINT } from './programConstarint/programConstraint.reducer';
import { PROCESS, processReducer } from './process/process.reducer';
import { processFlowReducer, PROCESS_FLOW } from './processFlow/processFlow.reducer';
import { processSupplierReducer, PROCESS_SUPPLIER } from './processSupplier/processSupplier.reducer';
import { processAddOnReducer, PROCESS_ADD_ON } from './processAddOn/processAddOn.reducer';
import { salesOrderReducer, SALES_ORDER } from './salesOrder/salesOrder.reducer';
import { salesOrderDetailsReducer, SALES_ORDER_DETAILS } from './salesOrder/salesOrderDetails/salesOrderDetails.reducer';
import CompactingDivisionAuthorize from '../screens/Programs/CompactingDivisionAuthorize/index.jsx';
import { COMPACTING_AUTHORIZATION, compactingDivAuthorizationReducer } from './programs/CompactingDivisionAuthorization/compactingDivAuthorization.reducer.js';
import { allInformationReducer, ALL_INFORMATION } from './stylePreparations/allInformation/allInformation.reducer';
import { fabricInformationReducer, FABRIC_INFORMATION } from './stylePreparations/fabricInformation/fabricInformation.reducer';
import {
    accessoriesRequirementReducer,
    ACCESSORIES_REQUIREMENTS
} from './stylePreparations/accessoriesRequirements/accessoriesRequirement.reducer';
import { processCostPerKgReducer, PROCESS_COST_PER_KG } from './stylePreparations/processCostPerKg/processCostPerKg.reducer';
import { processCostPerPcsReducer, PROCESS_COST_PER_PCS } from './stylePreparations/processCostPerPcs/processCostPerPcs.reducer';
import { partDetailsReducer, PART_DETAILS } from './stylePreparations/fabricInformation/partDetails/partDetails.reducer';
import { yarnInformationReducer, YARN_INFORMATION } from './stylePreparations/fabricInformation/yarnInformation/yarnInformation.reducer';
import { stylePreparationsReducer, STYLE_PREPARATION } from './stylePreparations/stylePreparation.reducer';
import { partMasterReducer, PART_MASTER } from './stylePreparations/fabricInformation/partMaster/partMaster.reducer';
import { pcsWeightReducer, PCS_WEIGHT } from './stylePreparations/fabricInformation/pcsWeight/pcsWeight.reducer';
import { stylePreDiaReducer, STYLE_PRE_DIA } from './stylePreparations/fabricInformation/stylePreDia/stylePreDia.reducer';
import { fabricPoMasterReducer, FABRIC_PO_MASTER } from './programs/FabricPo/fabricPoMaster/fabricPoMaster.reducer';
import { fabricPoDetailsReducer, FABRIC_PO_DETAILS } from './programs/FabricPo/fabricPoDetails/fabricPoDetails.reducer';
import { dyeingInwardHeaderReducer, DYEING_INWARD_MASTER } from './programs/DyeingDcInward/dyeingInwardHeader/dyeingInwardHeader.reducer';
import {
    dyeingInwardDetailsReducer,
    DYEING_INWARD_DETAILS
} from './programs/DyeingDcInward/dyeingInwardDetails/dyeingInwardDetails.reducer';
import { cuttingDCReducer, CUTTING_DC } from './programs/CuttingDc/cuttingDC/cuttingDC.reducer.js';
import { comboColorReducer, COMBO_COLOR } from './stylePreparations/fabricInformation/comboColor/comboColor.reducer';
import { yarnPOReducer, YARN_PO } from './programs/YarnPO/yarnPO/yarnPO.reducer';
import { yarnPODetailsReducer, YARN_PO_DETAILS } from './programs/YarnPO/yarnPODetails/yarnPODetails.reducer';
import { yarnInwardReducer, YARN_INWARD } from './programs/YarnInward/yarnInward/yarnInward.reducer';
import { yarnInwardDetailsReducer, YARN_INWARD_DETAILS } from './programs/YarnInward/yarnInwardDetails/yarnInwardDetails.reducer';
import { SECTION, sectionReducer } from './section/section.reducer';
import { knittingDCReducer, KNITTING_DC } from './programs/KnittingDC/knittingDC/knittingDC.reducer';
import { knittingDCDetailsReducer, KNITTING_DC_DETAILS } from './programs/KnittingDC/knittingDCDetails/knittingDCDetails.reducer';
import { generalPoMasterReducer, GENERAL_PO_MASTER } from './programs/GeneralPo/generalPoMaster/generalPoMaster.reducer';
import { generalPoDetailsReducer, GENERAL_PO_DETAILS } from './programs/GeneralPo/generalPoDetails/generalPoDetails.reducer';
import {
    printingDcInwardHeaderReducer,
    PRINTING_DC_INWARD_MASTER
} from './programs/PrintingDcInward/printingDcInwardHeader/printingDcInwardHeader.reducer';
import {
    printingDcInwardDetailsReducer,
    PRINTING_DC_INWARD_DETAILS
} from './programs/PrintingDcInward/printingDcInwardDetails/printingDcInwardDetails.reducer';
import { checkingDcMasterReducer, CHECKING_DC_MASTER } from './programs/CheckingDc/checkingDcMaster/checkingDcMaster.reducer.js';
import { checkingDcDetailsReducer, CHECKING_DC_DETAILS } from './programs/CheckingDc/checkingDcDetails/checkingDcDetails.reducer';
import { CONTRACTOR_BILL, contractorBillEntriesReducer } from './DKRequirements/contractorbill/contractorbill.reducer.js';
import {
    generalPoInwardHeaderReducer,
    GENERAL_PO_INWARD_MASTER
} from './programs/GeneralPoInward/generalPoInwardHeader/generalPoInwardHeader.reducer';
import {
    generalPoInwardDetailsReducer,
    GENERAL_PO_INWARD_DETAILS
} from './programs/GeneralPoInward/generalPoInwardDetails/generalPoInwardDetails.reducer';
import {
    accessoriesPoInwardHeaderReducer,
    ACCESSORIES_PO_INWARD_MASTER
} from './programs/AccessoriesPoInward/accessoriesPoInwardHeader/accessoriesPoInwardHeader.reducer';
import {
    accessoriesPoInwardDetailsReducer,
    ACCESSORIES_PO_INWARD_DETAILS
} from './programs/AccessoriesPoInward/accessoriesPoInwardDetails/accessoriesPoInwardDetails.reducer';
import {
    cuttingDcInwardHeaderReducer,
    CUTTING_DC_INWARD_MASTER
} from './programs/CuttingDcInward/cuttingDcInwardHeader/cuttingDcInwardHeader.reducer';
import {
    cuttingDcInwardDetailsReducer,
    CUTTING_DC_INWARD_DETAILS
} from './programs/CuttingDcInward/cuttingDcInwardDetails/cuttingDcInwardDetails.reducer';
import {
    generalDcInwardHeaderReducer,
    GENERAL_DC_INWARD_MASTER
} from './programs/GeneralDcInwardNew/generalDcInwardHeader/generalDcInwardHeader.reducer';
import {
    generalDcInwardDetailsReducer,
    GENERAL_DC_INWARD_DETAILS
} from './programs/GeneralDcInwardNew/generalDcInwardDetails/generalDcInwardDetails.reducer';
import {
    checkingDcInwardHeaderReducer,
    CHECKING_DC_INWARD_MASTER
} from './programs/CheckingDcInward/checkingDcInwardHeader/checkingDcInwardHeader.reducer';
import {
    checkingDcInwardDetailsReducer,
    CHECKING_DC_INWARD_DETAILS
} from './programs/CheckingDcInward/checkingDcInwardDetails/checkingDcInwardDetails.reducer';
import { fabricInwardReducer, FABRIC_INWARD } from './programs/FabricInward/fabricInward/fabricInward.reducer';
import { fabricInwardDetailsReducer, FABRIC_INWARD_DETAILS } from './programs/FabricInward/fabricInwardDetails/fabricInwardDetails.reducer';
import { knittingInwardReducer, KNITTING_INWARD } from './programs/KnittingInward/knittingInward/knittingInward.reducer';
import {
    knittingInwardDetailsReducer,
    KNITTING_INWARD_DETAILS
} from './programs/KnittingInward/knittingInwardDetails/knittingInwardDetails.reducer';
import { dyeingDcReducer, DYEING_DC } from './programs/DyeingDC/dyeingDC/dyeingDC.reducer';
import { dyeingDCDetailsReducer, DYEING_DC_DETAILS } from './programs/DyeingDC/dyeingDCDetails/dyeingDCDetails.reducer';
import { compactingDcReducer, COMPACTING_DC } from './programs/CompactingDC/compactingDC/compactingDC.reducer';
import { compactingDCDetailsReducer, COMPACTING_DC_DETAILS } from './programs/CompactingDC/compactingDCDetails/compactingDCDetails.reducer';
import { compactingDivisionReducer, COMPACTING_DIVISION } from './programs/CompactingDivisonDC/compactingDivision/compactingDivision.reducer.js';
import { compactingDivisionDetailsReducer, COMPACTING_DIVISION_DETAILS } from './programs/CompactingDivisonDC/compactingDivisionDetails/compactingDivisionDetails.reducer.js';
import { compactingInwardReducer, COMPACTING_INWARD } from './programs/CompactingInward/compactingInward/compactingInward.reducer';
import { compactingDivisionInwardReducer, COMPACTING_DIVISION_INWARD } from './programs/CompactingDivisionDCInward/compactingDivisionInward/compactingDivInward.reducer.js';
import {
    compactingInwardDetailsReducer,
    COMPACTING_INWARD_DETAILS
} from './programs/CompactingInward/compactingInwardDetails/compactingInwardDetails.reducer';
import {
    compactingDivisionInwardDetailsReducer,
    COMPACTING_DIVISION_INWARD_DETAILS
} from './programs/CompactingDivisionDCInward/compactingDivInwardDetails/compactingInwardDetails.reducer.js'

import { printingDcReducer, PRINTING_DC } from './programs/PrintingDC/printingDC/printingDC.reducer';

import { accessoriesDCReducer, ACCESSORIES_DC } from './programs/AccessoriesDC/accessoriesDC/accessoriesDC.reducer';

import { accessoriesPOReducer, ACCESSORIES_PO } from './programs/AccessoriesPO/accessoriesPO/accessoriesPO.reducer';
import {
    accessoriesPODetailsReducer,
    ACCESSORIES_PO_DETAILS
} from './programs/AccessoriesPO/accessoriesPODetails/accessoriesPODetails.reducer';

import { PIM, PimReducer } from './pim/pim.reducer';
import { billPaymentDetailsReducer, BILL_PAYMENT_DETAILS } from './billPayment/billPaymentDetails/billPaymentDetails.reducer';
import { billPaymentMasterReducer, BILL_PAYMENT_MASTER } from './billPayment/billPaymentHeader/billPaymentHeader.reducer';
import { pimDetailsReducer, PIM_DETAILS } from './pimDetails/pimDetails.reducer';
import { pimAdditionalExpenseReducer, PIM_ADDITIONAL_EXPENSE } from './pimAdditionalExpense/pimAdditionalExpense.reducer';
import { processAssignStyleMasterReducer, PROCESS_ASSIGN_STYLE_MASTER } from './processAssignStyleMaster/processAssignStyleMaster.reducer';
import { yarnMasterReducer, YARN_MASTER } from './yarnMaster/yarnMaster.reducer';
import { fabricMasterReducer, FABRIC_MASTER } from './fabricMaster/fabricMaster.reducer';
import { salesOrderDemandReducer, SALES_ORDER_DEMAND } from './salesOrderDemand/salesOrderDemand.reducer';
import { STYLE_MASTER_MAIN, styleMasterMainReducer } from './styleMasterMain/styleMasterMain.reducer';

import { yarnPODKReducer, YARN_PO_DK } from './DKRequirements/programs/YarnPO/yarnPO/yarnPO.reducer';
import { yarnPODKDetailsReducer, YARN_PO_DK_DETAILS } from './DKRequirements/programs/YarnPO/yarnPODetails/yarnPODetails.reducer';
import { yarnInwardDKReducer, YARN_INWARD_DK } from './DKRequirements/programs/YarnInward/yarnInward/yarnInward.reducer';
import {
    yarnInwardDKDetailsReducer,
    YARN_INWARD_DK_DETAILS
} from './DKRequirements/programs/YarnInward/yarnInwardDetails/yarnInwardDetails.reducer';
import { fabricInwardDKReducer, FABRIC_INWARD_DK } from './DKRequirements/programs/FabricInward/fabricInward/fabricInward.reducer';
import {
    fabricInwardDKDetailsReducer,
    FABRIC_INWARD_DETAILS_DK
} from './DKRequirements/programs/FabricInward/fabricInwardDetails/fabricInwardDetails.reducer';
import { styleMasterBasicReducer, STYLE_MASTER_BASIC } from './DKRequirements/styleMasterBasic/styleMasterBasic.reducer';
import { skuMasterHeaderReducer, SKU_MASTER_HEADER } from './DKRequirements/skuMaster/skuMasterHeader/skuMasterHeader.reducer';
import { skuMasterDetailsReducer, SKU_MASTER_DETAILS } from './DKRequirements/skuMaster/skuMasterDetails/skuMasterDetails.reducer';
import {
    knittingInwardDKReducer,
    KNITTING_INWARD_DK
} from './DKRequirements/programs/KnittingInward/knittingInward/knittingInward.reducer';
import {
    knittingInwardDetailsDKReducer,
    KNITTING_INWARD_DETAILS_DK
} from './DKRequirements/programs/KnittingInward/knittingInwardDetails/knittingInwardDetails.reducer';
import { fabricPoMasterDKReducer, FABRIC_PO_MASTER_DK } from './DKRequirements/programs/FabricPo/fabricPoMaster/fabricPoMaster.reducer';
import { fabricPoDetailsDKReducer, FABRIC_PO_DETAILS_DK } from './DKRequirements/programs/FabricPo/fabricPoDetails/fabricPoDetails.reducer';
import { dyeingDcDKReducer, DYEING_DC_DK } from './DKRequirements/programs/DyeingDC/dyeingDC/dyeingDC.reducer';
import {
    dyeingInwardDKHeaderReducer,
    DYEING_INWARD_DK_MASTER
} from './DKRequirements/programs/DyeingDcInward/dyeingInwardHeader/dyeingInwardHeader.reducer';
import {
    dyeingInwardDKDetailsReducer,
    DYEING_INWARD_DK_DETAILS
} from './DKRequirements/programs/DyeingDcInward/dyeingInwardDetails/dyeingInwardDetails.reducer';
import { processDKReducer, PROCESS_DK } from './DKRequirements/process/process.reducer';
import { processFlowDKReducer, PROCESS_FLOW_DK } from './DKRequirements/processFlow/processFlow.reducer';
import { processAddOnDKReducer, PROCESS_ADD_ON_DK } from './DKRequirements/processAddOn/processAddOn.reducer';
import { processSupplierDKReducer, PROCESS_SUPPLIER_DK } from './DKRequirements/processSupplier/processSupplier.reducer';
import {
    processAssignStyleMasterDKReducer,
    PROCESS_ASSIGN_STYLE_MASTER_DK
} from './DKRequirements/processAssignStyleMaster/processAssignStyleMaster.reducer';
import { knittingDCDKReducer, KNITTING_DC_DK } from './DKRequirements/programs/KnittingDC/knittingDC/knittingDC.reducer';
import {
    knittingDCDKDetailsReducer,
    KNITTING_DC_DETAILS_DK
} from './DKRequirements/programs/KnittingDC/knittingDCDetails/knittingDCDetails.reducer';
import {
    generalPoMasterDKReducer,
    GENERAL_PO_MASTER_DK
} from './DKRequirements/programs/GeneralPo/generalPoMaster/generalPoMaster.reducer';
import {
    generalPoDetailsDKReducer,
    GENERAL_PO_DETAILS_DK
} from './DKRequirements/programs/GeneralPo/generalPoDetails/generalPoDetails.reducer';
import { generalInwardDKReducer, GENERAL_INWARD_DK } from './DKRequirements/programs/GeneralPoInward/generalInward/generalInward.reducer';
import {
    generalInwardDKDetailsReducer,
    GENERAL_INWARD_DETAILS_DK
} from './DKRequirements/programs/GeneralPoInward/generalInwardDetails/generalInwardDetails.reducer';
import { dyeingDCDetailsDKReducer, DYEING_DC_DETAILS_DK } from './DKRequirements/programs/DyeingDC/dyeingDCDetails/dyeingDCDetails.reducer';
import { generalDcMasterReducer, GENERAL_DC_MASTER } from './programs/GeneralDcNew/generalDcMaster/generalDcMaster.reducer';
import { generalDcDetailsReducer, GENERAL_DC_DETAILS } from './programs/GeneralDcNew/generalDcDetails/generalDcDetails.reducer';
import {
    generalDCDKReducer,
    generalDcMasterDKReducer,
    GENERAL_DC_DK,
    GENERAL_DC_MASTER_DK
} from './DKRequirements/programs/GeneralDC/generalDC/generalDC.reducer';
import {
    generalDcDetailsDKReducer,
    generalDCDKDetailsReducer,
    GENERAL_DC_DETAILS_DK
} from './DKRequirements/programs/GeneralDC/generalDCDetails/generalDCDetails.reducer';
import {
    generalDCInwardDKReducer,
    GENERAL_DC_INWARD_DK
} from './DKRequirements/programs/GeneralDCInward/generalDCInward/generalDCInward.reducer';
import {
    generalDCInwardDetailsDKReducer,
    GENERAL_DC_INWARD_DETAILS_DK
} from './DKRequirements/programs/GeneralDCInward/generalDCInwardDetails/generalDCInwardDetails.reducer';
import {
    printingDcInwardDKHeaderReducer,
    PRINTING_DC_INWARD_MASTER_DK
} from './DKRequirements/programs/PrintingDcInward/printingDcInwardHeader/printingDcInwardHeader.reducer';
import {
    printingDcInwardDKDetailsReducer,
    PRINTING_DC_INWARD_DETAILS_DK
} from './DKRequirements/programs/PrintingDcInward/printingDcInwardDetails/printingDcInwardDetails.reducer';
import {
    accessoriesPoMasterDKReducer,
    ACCESSORIES_PO_MASTER_DK
} from './DKRequirements/programs/AccessoriesPo/accessoriesPoMaster/accessoriesPoMaster.reducer';
import {
    accessoriesPoDetailsDKReducer,
    ACCESSORIES_PO_DETAILS_DK
} from './DKRequirements/programs/AccessoriesPo/accessoriesPoDetails/accessoriesPoDetails.reducer';
import {
    accessoriesInwardDKReducer,
    ACCESSORIES_INWARD_DK
} from './DKRequirements/programs/AccessoriesPoInward/accessoriesInward/accessoriesInward.reducer';
import {
    accessoriesInwardDKDetailsReducer,
    ACCESSORIES_INWARD_DETAILS_DK
} from './DKRequirements/programs/AccessoriesPoInward/accessoriesInwardDetails/accessoriesInwardDetails.reducer';
import { printingDcDKReducer, PRINTING_DC_DK } from './DKRequirements/programs/PrintingDC/printingDC/printingDC.reducer';
import {
    printingDCDetailsDKReducer,
    PRINTING_DC_DETAILS_DK
} from './DKRequirements/programs/PrintingDC/printingDCDetails/printingDCDetails.reducer';
import {
    compactingInwardDKReducer,
    COMPACTING_INWARD_DK
} from './DKRequirements/programs/CompactingInward/compactingInward/compactingInward.reducer';
import {
    compactingInwardDetailsDKReducer,
    COMPACTING_INWARD_DETAILS_DK
} from './DKRequirements/programs/CompactingInward/compactingInwardDetails/compactingInwardDetails.reducer';
import { compactingDcDKReducer, COMPACTING_DC_DK } from './DKRequirements/programs/CompactingDC/compactingDC/compactingDC.reducer';
import { washingDcDKReducer, WASHING_DC_DK } from './DKRequirements/programs/WashingDC/washingDC/washingDC.reducer';
import {
    washingDCDetailsDKReducer,
    WASHING_DC_DETAILS_DK
} from './DKRequirements/programs/WashingDC/washingDCDetails/washingDCDetails.reducer';
import {
    washingInwardDKHeaderReducer,
    WASHING_INWARD_DK_MASTER
} from './DKRequirements/programs/WashingDcInward/washingInwardHeader/washingInwardHeader.reducer';
import {
    washingInwardDKDetailsReducer,
    WASHING_INWARD_DK_DETAILS
} from './DKRequirements/programs/WashingDcInward/washingInwardDetails/washingInwardDetails.reducer';
import { cuttingDcDKReducer, CUTTING_DC_DK } from './DKRequirements/programs/CuttingDC/cuttingDC/cuttingDC.reducer.js';
import {
    cuttingDCDetailsDKReducer,
    CUTTING_DC_DETAILS_DK
} from './DKRequirements/programs/CuttingDC/cuttingDCDetails/cuttingDCDetails.reducer.js';
import {
    compactingDCDKDetailsReducer,
    COMPACTING_DC_DETAILS_DK
} from './DKRequirements/programs/CompactingDC/compactingDCDetails/compactingDCDetails.reducer';
import { accessoriesDCDKReducer, ACCESSORIES_DC_DK } from './DKRequirements/programs/AccessoriesDC/accessoriesDC/accessoriesDC.reducer';
import {
    accessoriesDCDKDetailsReducer,
    ACCESSORIES_DC_DETAILS_DK
} from './DKRequirements/programs/AccessoriesDC/accessoriesDCDetails/accessoriesDCDetails.reducer';
import {
    ironingPackingInwardDKHeaderReducer,
    IRONING_PACKING_INWARD_DK_MASTER
} from './DKRequirements/programs/IroningPackingDcInward/ironingPackingInwardHeader/ironingPackingInwardHeader.reducer';
import {
    ironingPackingInwardDKDetailsReducer,
    IRONING_PACKING_INWARD_DK_DETAILS
} from './DKRequirements/programs/IroningPackingDcInward/ironingPackingInwardDetails/ironingPackingInwardDetails.reducer';
import { asanaErrorPointsReducer, ASANAERROR_POINTS } from './AsanaErrorPoints/asanaErrorPoints.reducer';

import { printingDCDetailsReducer, PRINTING_DC_DETAILS } from './programs/PrintingDC/printingDCDetails/printingDCDetails.reducer';
import { dashboardDKReducer, DASHBOARD_DK } from './DKRequirements/dashboard/dashboard.reducer';
import { reportDKReducer, REPORT_DK } from './DKRequirements/reports/programWiseReport/programWiseReport.reducer';
import { billEntryReports, BILL_ENTRY_REPORT } from './DKRequirements/reports/billentryReports/billEntryReport.reducer';
import {
    cuttingInwardDKHeaderReducer,
    CUTTING_INWARD_DK_MASTER
} from './DKRequirements/programs/CuttingDcInward/cuttingInwardHeader/cuttingInwardHeader.reducer';
import {
    cuttingInwardDKDetailsReducer,
    CUTTING_INWARD_DK_DETAILS
} from './DKRequirements/programs/CuttingDcInward/cuttingInwardDetails/cuttingInwardDetails.reducer';
import { printingDc2DKReducer, PRINTING_DC2_DK } from './DKRequirements/programs/PrintingDC2/printingDC2/printingDC2.reducer';
import {
    printingDC2DetailsDKReducer,
    PRINTING_DC2_DETAILS_DK
} from './DKRequirements/programs/PrintingDC2/printingDC2Details/printingDC2Details.reducer';
import {
    printing2InwardDKHeaderReducer,
    PRINTING2_INWARD_DK_MASTER
} from './DKRequirements/programs/PrintingDc2Inward/printing2InwardHeader/printing2InwardHeader.reducer';
import {
    printing2InwardDKDetailsReducer,
    PRINTING2_INWARD_DK_DETAILS
} from './DKRequirements/programs/PrintingDc2Inward/printing2InwardDetails/printing2InwardDetails.reducer';
import {
    stitchingInwardDKHeaderReducer,
    STITCHING_INWARD_DK_MASTER
} from './DKRequirements/programs/StitchingDcInward/stitchingInwardHeader/stitchingInwardHeader.reducer';
import {
    stitchingInwardDKDetailsReducer,
    STITCHING_INWARD_DK_DETAILS
} from './DKRequirements/programs/StitchingDcInward/stitchingInwardDetails/stitchingInwardDetails.reducer';
import {
    ironingPackingDCDetailsDKReducer,
    IRONING_PACKING_DC_DETAILS_DK
} from './DKRequirements/programs/IroningPackingDC/IroningPackingDCDetails/ironingPackingDCDetails.reducer.js';
import {
    ironingPackingDcDKReducer,
    IRONING_PACKING_DC_DK
} from './DKRequirements/programs/IroningPackingDC/ironingPackingDC/ironingPackingDC.reducer';

import { stitchingDcDKReducer, STITCHING_DC_DK } from './DKRequirements/programs/StitchingDC/stitchingDC/stitchingDC.reducer';
import {
    stitchingDCDetailsDKReducer,
    STITCHING_DC_DETAILS_DK
} from './DKRequirements/programs/StitchingDC/stitchingDCDetails/stitchingDCDetails.reducer';
import { FILTER, filterReducer } from './filter/filter.reducer';
import { BARCODE_MASTER, barcodeMasterReducer } from './barcodeMaster/barcodeMaster.reducer';
import { STITCHING_DC, stitchingDCReducer } from './programs/StitchingDC/stitchingDC/stitchingDC.reducer';
import { STITCHING_DC_DETAILS, stitchingDCDetailsReducer } from './programs/StitchingDC/stitchingDCDetails/stitchingDCDetails.reducer';
import { STITCHING_INWARD, stitchingInwardReducer } from './programs/StitchingInward/stitchingInward/stitchingInward.reducer';
import {
    STITCHING_INWARD_DETAILS,
    stitchingInwardDetailsReducer
} from './programs/StitchingInward/stitchingInwardDetails/stitchingInwardDetails.reducer';
import { DESPATCH_DC, despatchDCReducer } from './programs/DespatchDC/despatchDC/despatchDC.reducer';
import { DESPATCH_DC_DETAILS, despatchDCDetailsReducer } from './programs/DespatchDC/despatchDCDetails/despatchDCDetails.reducer';
import { COSTING_HEADER, costingHeaderReducer } from './programs/Costing/CostingHeader/costingHeader.reducer';
import { CASH, cashRequisitionReducer } from './programs/CashRequisition/cashRequisition.reducer.js';
import {
    CASH_REQUISITION_DETAILS,
    CashRequisitionDetailsReducer
} from './programs/CashRequisition/CashRequisitionDetails/CashRequisitionDetails.reducer.js';
import { ALL_OVER_PRINTING_DC, allOverPrintingDcReducer } from './programs/AllOverPrintingDC/printingDC/printingDC.reducer';
import {
    ALL_OVER_PRINTING_DC_INWARD_DETAILS,
    allOverPrintingDcInwardDetailsReducer
} from './programs/AllOverPrintingDCInward/printingDcInwardDetails/printingDcInwardDetails.reducer';
import {
    ALL_OVER_PRINTING_DC_INWARD_MASTER,
    allOverPrintingDcInwardHeaderReducer
} from './programs/AllOverPrintingDCInward/printingDcInwardHeader/printingDcInwardHeader.reducer';
import {
    ALL_OVER_PRINTING_DC_DETAILS,
    allOverPrintingDCDetailsReducer
} from './programs/AllOverPrintingDC/printingDCDetails/printingDCDetails.reducer';

import {
    IRONING_AND_PACKING_INWARD,
    ironingAndPackingInwardReducer
} from './programs/IroningAndPackingInward/ironingAndPackingInward/ironingAndPackingInward.reducer';
import {
    IRONING_AND_PACKING_INWARD_DETAILS,
    ironingAndPackingInwardDetailsReducer
} from './programs/IroningAndPackingInward/ironingAndPackingInwardDetails/ironingAndPackingInwardDetails.reducer';
import { REPORT_STOCK_DK, reportStockDKReducer } from './DKRequirements/reports/programWiseReport/stockWiseReport/stockWiseReports.reducer';
import {
    REPORT_STOCK_LEDGER_DK,
    reportStockLedgerDKReducer
} from './DKRequirements/reports/programWiseReport/stockWiseReportLedger/stockWiseReportsLedger.reducer';
import {
    STOCKWISEREPORTSLEDGER_DK_DETAILS,
    stockLedgerDKDetailsReducer
} from './DKRequirements/reports/programWiseReport/stockWiseReportsLedgerDetails/stockWiseReportsLedgerDetails.reducer';
import { IRONING_PACKING_DC, ironingPackingDcReducer } from './programs/IroningPackingDC/IroningPackingDC/ironingPackingDC.reducer.js';
import { CUTTING_DC_DETAILS, cuttingDCDetailsReducer } from './programs/CuttingDc/cuttingDcDetails/cuttingDcDetails.reducer';
import { Bill_Entries_DK, billEntriesDKReducer } from './DKRequirements/billEntries/billEntries.reducer.js';
import { EDIT_ENTRIES, editEntriesReducer } from './DKRequirements/billeditentries/editentries.reducer.js';
import { VERIFIED_BILLS, verifiedBillsReducer } from './DKRequirements/verifiedBillEdit/verifiedBills.reducer.js';
import { GARMENTS_PO, garmentsPoReducer } from './programs/GarmentsPO/garmentsPO/garmentsPO.reducer.js';
import { GARMENTS_PO_DETAILS, garmentsPODetailsReducer } from './programs/GarmentsPO/garmentsPODetails/garmentsPoDetails.reducer.js';
import { GARMENTS_PO_INWARD_MASTER, garmentsPoInwardHeaderReducer } from './programs/GarmentsPoInward/garmentsPoInwardHeader/garmentsPoInwardHeader.reducer.js';
import { GARMENTS_PO_INWARD_DETAILS, garmentsPoInwardDetailsReducer } from './programs/GarmentsPoInward/garmentsPoInwardDetails/garmentsPoInwardDetails.reducer.js';
import { YARN_PROJECTION, yarnProjectionReducer } from './yarnProjection/yarnProjection.reducer.js';
import { FABRIC_PROJECTION, fabricProjectionReducer } from './fabricProjection/fabricProjection.reducer.js';
import { CUTTING_PROGRAM, cuttingProgramReducer } from './cuttingProgram/cuttingProgram.reducer.js';
import { STYLE_WISE_REPORT, styleWiseReportsReducer } from './DKRequirements/reports/styleWiseReports/styleWiseReport.reducer.js';
import { SUPPLIER_WISE_REPORT, supplierWiseReportsReducer } from './DKRequirements/reports/supplierWiseReport/supplierWiseReport.reducer.js';
import { SHIPPING_PLAN, shippingReducer } from './shippingPlan/shippingPlan.reducer.js';
import { SHIPPING_PLAN_DETAILS, shippingDetailsReducer } from './shippingPlan/shippingPlanDetails/shippingPlanDetails.reducer.js';
import { BILL_ENTRY_REPORTS_ALL, billEntryReportsAllReducer } from './DKRequirements/reports/billEntryReportsAll/billEntryReportsAll.reducer.js';
import { CLOSE_BILL_ENTRY, closebillEntryReducer } from './DKRequirements/closebillReport/closebillReport.reducer.js';
import { REPORTS_ALL, reportsAllReducer } from './DKRequirements/reports/reportsAll/reportsAll.reducer.js';
import { ACCOUNT_MASTER, accountMasterReducer } from './accountMaster/accountMaster.reducer.js';
import { ACCOUNT_PROPERTY, AccountPropertyReducer } from './programs/AccountProperty/AccountProperty.reducer.js';
import { ACCESSORIES_DC_DETAILS, accessoriesDCDetailsReducer } from './programs/AccessoriesDC/accessoriesDCDetails/accessoriesDCDetails.reducer.js';
import { COMPACTING_REPORT, compactingReportsReducer } from './DKRequirements/reports/compactingReport/compactingReport.reducer.js';
import { ACCESSORIES_PROCESS_DC, accessoriesProcessDCReducer } from './programs/AccessoriesProcessDC/accessoriesProcessDC/accessoriesProcessDC.reducer.js';
import { ACCESSORIES_PROCESS_DC_DETAILS, accessoriesProcessDCDetailsReducer } from './programs/AccessoriesProcessDC/accessoriesProcessDCDetails/accessoriesProcessDCDetails.reducer.js';
import { IRONING_PACKING_DC_DETAILS, ironingPackingDCDetailsReducer } from './programs/IroningPackingDC/IroningPackingDCDetails/IroningPackingDCDetails.reducer.js';
import { ACCESSORIES_PROCESS_DC_INWARD_DETAILS, accessoriesProcessDCInwardDetailsReducer } from './programs/AccessoriesProcessDCInward/accessoriesProcessDCInwardDetails/accessoriesProcessDCInwardDetails.reducer.js';
import { ACCESSORIES_PROCESS_DC_INWARD_MASTER, accessoriesProcessDCInwardHeaderReducer } from './programs/AccessoriesProcessDCInward/accessoriesProcessDCInwardHeader/accessoriesProcessDCInwardHeader.reducer.js';
import { VENDOR_MANAGEMENT, vendorManagementReducer } from './vendorManagement/vendorManagement.reducer.js';
import { VENDOR_MASTER, vendorMasterReducer } from './vendorMaster/vendorMaster.reducer.js';
import { PRICE_LIST, PriceListReducer } from './programs/PriceList/PriceList.reducer.js';
import { CUTTING_REPORTS, cuttingReportsReducer } from './cuttingReports/cuttingReports.reducer.js';
import { ACCOUNT_PROPERTY_MODAL, accountPropertyModalReducer } from './programs/AccountProperty/AccountPropertyModal/AccountPropertyModal.reducer.js';
import { PRODUCTION_REPORT, productionReportsReducer } from './DKRequirements/reports/productionReport/productionReport.reducer.js';
import { DYEING_DETAILS, DyeingDetailsReducer } from './programs/DyeingDetails/DyeingDetails.reducer.js';
import { RN_PENDING, rnpendinreportReducer } from './DKRequirements/reports/rnPendingReport/rnPendingReport.reducer.js';
import { REQUEST_FORM, requestFormReducer } from './requestForm/requestForm.reducer.js';
import { DIRECT_BILLING, directBillingReducer } from './programs/DirectBilling/directBilling.reducer.js';
import { DIRECT_BILLING_DETAILS, directBillingDetailsReducer } from './programs/DirectBilling/DirectBillingDetails/directBillingDetails.reducer.js';

import { PRODUCT_DISPATCH, productDispatchReducer } from './DKRequirements/reports/productDispatch/productDispatch.reducer.js';
import { PRODUCT_STOCK, productStockReducer } from './DKRequirements/reports/productStock/productStock.reducer.js';
import { PACKING_ENTRY, packingEntryReducer } from './packingEntry/packingEntry.reducer.js';
import { SETTINGS, settingsReducer } from './settings/settings.reducer.js';
import { AUDIT_TRIAL, auditTrialReducer } from './auditTrial/auditTrial.reducer.js';
import { MOVE_TO_CUTTING, moveToCuttingReducer } from './DKRequirements/programs/moveToCutting/moveToCutting.reducer.js';
import { FABRIC_REPORT, fabricReportReducer } from './DKRequirements/reports/fabricReport/fabricReport.reducer.js';
import { BILL_RECEIVING, billReceivingReducer } from './DKRequirements/BillsReceived/billsReceived.reducer.js';
import { BILL_RECEIVING_REPORT, billReceivingReportReducer } from './DKRequirements/billReceivingReport/billReceivingReport.reducer.js';
import { BILL_RECEIVING_VERIFY, billReceivingVerifyReducer } from './DKRequirements/billReceivingVerify/billReceivingVerify.reducer.js';
import { PROGRAM_DISCOUNT, programDiscountReducer } from './DKRequirements/programDiscount/programDiscount.reducer.js';
import { ARTICLE_MASTER, articleMasterReducer } from './articleMaster/articleMaster.reducer.js';
import { WAREHOUSE_STYLE, warehouseStyleReducer } from './programs/WarehouseStyle/warehouseStyle.reducer.js';
import { WAREHOUSE_STYLE_DETAILS, warehouseStyleDetailsReducer } from './programs/WarehouseStyleDetails/warehouseStyleDetails.reducer.js';
import { CUSTOMER_PO, customerPOReducer } from './programs/CustomerPO/CustomerPO/customerPO.reducer.js';
import { CUSTOMER_PO_DETAILS, customerPODetailsReducer } from './programs/CustomerPO/CustomerPODetails/customerPODetails.reducer.js';
import { ROUGH_FABRIC_COSTING, roughFabricCosting } from './programs/RoughCosting/RoughFabricCosting/roughFabricCosting.reducer.js';

// import { PROJECTION_REPORT, projectionReportsReducer } from './DKRequirements/reports/projectionReport/projectionReport.reducer.js';
//import { GARMENTS_PO, garmentsPoReducer } from './programs/GarmentsPO/garmentsPo/garmentsPo.reducer.js';
const reducer = combineReducers({
    able: ableReducer,
    demo: demoReducer,
    [PROPERTY_MASTER]: propertyMasterReducer,
    [SETTINGS]: settingsReducer,
    [AUDIT_TRIAL]: auditTrialReducer,
    [NAVIGATION]: navigationReducer,
    [PROPERTY]: propertyReducer,
    [COMMON_PROPERTY]: commonPropertyReducer,
    [STATE_MASTER]: stateMasterReducer,
    [USER_HEADER]: userHeaderReducer,
    [FILTER]: filterReducer,
    [COMPANY_MASTER]: companyMasterReducer,
    [UNIT_MASTER]: unitMasterReducer,
    [MENU_MASTER]: menuMasterReducer,
    [AREA_MASTER]: companyAreaReducer,
    [ROLES]: rolesReducer,
    [USER_DETAILS]: userDetailsReducer,
    [COLOR_MASTER]: colorReducer,
    [COLOR_DETAILS]: colorDetailsReducer,
    [TEAM_MASTER]: teamMasterReducer,
    [TEAM_DETAILS]: teamDetailsReducer,
    [PARTY_MASTER]: partyMasterReducer,
    [VENDOR_MASTER]: vendorMasterReducer,
    [PARTY_DETAILS]: partyDetailsReducer,
    [EMPLOYEE]: employeeReducer,
    [SIZE_INFO]: sizeInfoReducer,
    [SIZE_RATIO]: sizeRatioReducer,
    [YEAR_MASTER]: yearMasterReducer,
    [SEASON_MASTER]: seasonMasterReducer,
    [SIZE_MEASUREMENT_MASTER]: sizeMeasurementReducer,
    [SIZE_MEASUREMENT_DETAILS]: sizeMeasurementDetailsReducer,
    [ACCESS_INFO_AND_DETAILS]: accessInfoAndDetailsReducer,
    [BANK_MASTER]: bankMasterReducer,
    [ACCOUNT_MASTER]: accountMasterReducer,
    [HSN_MASTER]: hsnMasterReducer,
    [BRAND_MASTER]: brandMasterReducer,
    [PRICE_MAPPING]: priceMappingReducer,
    [PRICE_LIST]: PriceListReducer,
    [ACCESSORIS_MASTER]: accessoriesMasterReducer,
    [BARCODE_MASTER]: barcodeMasterReducer,
    [ACCESSORIES_USAGE]: accessoriesUsageReducer,
    [STOCK]: stockReducer,
    [PRODUCT_MASTER]: productMasterReducer,
    [PRODUCT_DETAILS]: productDetailsReducer,
    [STYLE_MASTER]: styleMasterReducer,
    [STYLE_DETAIL]: styleDetailReducer,
    [FEEDBACK_MASTER]: feedbacktMasterReducer,
    [FEEDBACK_DETAILS]: feedbackDetailsReducer,
    [DEFAULT_STYLE_MASTER]: defaultStyleMasterReducer,
    [PROGRAM_MAPPING]: programMappingReducer,
    [PROGRAM_CONSTRAINT]: programConstraintReducer,
    [PROCESS]: processReducer,
    [PROCESS_FLOW]: processFlowReducer,
    [PROCESS_SUPPLIER]: processSupplierReducer,
    [PROCESS_ADD_ON]: processAddOnReducer,
    [SALES_ORDER]: salesOrderReducer,
    [SALES_ORDER_DETAILS]: salesOrderDetailsReducer,
    [CUTTING_PROGRAM]: cuttingProgramReducer,
    [ALL_INFORMATION]: allInformationReducer,
    [FABRIC_INFORMATION]: fabricInformationReducer,
    [ACCESSORIES_REQUIREMENTS]: accessoriesRequirementReducer,
    [PROCESS_COST_PER_KG]: processCostPerKgReducer,
    [PROCESS_COST_PER_PCS]: processCostPerPcsReducer,
    [PART_DETAILS]: partDetailsReducer,
    [YARN_INFORMATION]: yarnInformationReducer,
    [STYLE_PREPARATION]: stylePreparationsReducer,
    [PART_MASTER]: partMasterReducer,
    [PCS_WEIGHT]: pcsWeightReducer,
    [STYLE_PRE_DIA]: stylePreDiaReducer,
    [FABRIC_PO_MASTER]: fabricPoMasterReducer,
    [FABRIC_PO_DETAILS]: fabricPoDetailsReducer,
    [YARN_PO]: yarnPOReducer,
    [YARN_PO_DETAILS]: yarnPODetailsReducer,
    [DYEING_INWARD_MASTER]: dyeingInwardHeaderReducer,
    [DYEING_INWARD_DETAILS]: dyeingInwardDetailsReducer,
    [CUTTING_DC]: cuttingDCReducer,
    [CUTTING_REPORTS]: cuttingReportsReducer,
    [GARMENTS_PO]: garmentsPoReducer,
    [GARMENTS_PO_DETAILS]: garmentsPODetailsReducer,
    [CUSTOMER_PO]: customerPOReducer,
    [CUSTOMER_PO_DETAILS]: customerPODetailsReducer,
    [GARMENTS_PO_INWARD_MASTER]: garmentsPoInwardHeaderReducer,
    [GARMENTS_PO_INWARD_DETAILS]: garmentsPoInwardDetailsReducer,
    [COMBO_COLOR]: comboColorReducer,
    [CUTTING_DC_DETAILS]: cuttingDCDetailsReducer,
    [YARN_INWARD]: yarnInwardReducer,
    [YARN_INWARD_DETAILS]: yarnInwardDetailsReducer,
    [SECTION]: sectionReducer,
    [FABRIC_INWARD]: fabricInwardReducer,
    [FABRIC_INWARD_DETAILS]: fabricInwardDetailsReducer,
    [KNITTING_DC]: knittingDCReducer,
    [KNITTING_DC_DETAILS]: knittingDCDetailsReducer,
    [KNITTING_INWARD]: knittingInwardReducer,
    [KNITTING_INWARD_DETAILS]: knittingInwardDetailsReducer,
    [DYEING_DC]: dyeingDcReducer,
    [DYEING_DC_DETAILS]: dyeingDCDetailsReducer,
    [COMPACTING_DC]: compactingDcReducer,
    [COMPACTING_DC_DETAILS]: compactingDCDetailsReducer,
    [COMPACTING_DIVISION]: compactingDivisionReducer,
    [COMPACTING_DIVISION_DETAILS]: compactingDivisionDetailsReducer,
    [COMPACTING_AUTHORIZATION]: compactingDivAuthorizationReducer,
    [COMPACTING_INWARD]: compactingInwardReducer,
    [COMPACTING_INWARD_DETAILS]: compactingInwardDetailsReducer,
    [COMPACTING_DIVISION_INWARD]: compactingDivisionInwardReducer,
    [COMPACTING_DIVISION_INWARD_DETAILS]: compactingDivisionInwardDetailsReducer,
    [PRINTING_DC]: printingDcReducer,
    [ALL_OVER_PRINTING_DC]: allOverPrintingDcReducer,
    [ALL_OVER_PRINTING_DC_DETAILS]: allOverPrintingDCDetailsReducer,
    [ALL_OVER_PRINTING_DC_INWARD_MASTER]: allOverPrintingDcInwardHeaderReducer,
    [ALL_OVER_PRINTING_DC_INWARD_DETAILS]: allOverPrintingDcInwardDetailsReducer,
    [STITCHING_DC]: stitchingDCReducer,
    [STITCHING_DC_DETAILS]: stitchingDCDetailsReducer,
    [STITCHING_INWARD]: stitchingInwardReducer,
    [STITCHING_INWARD_DETAILS]: stitchingInwardDetailsReducer,
    [IRONING_AND_PACKING_INWARD]: ironingAndPackingInwardReducer,
    [IRONING_AND_PACKING_INWARD_DETAILS]: ironingAndPackingInwardDetailsReducer,
    [ACCESSORIES_DC]: accessoriesDCReducer,
    [ACCESSORIES_DC_DETAILS]: accessoriesDCDetailsReducer,
    [ACCESSORIES_PROCESS_DC]: accessoriesProcessDCReducer,
    [ACCESSORIES_PROCESS_DC_DETAILS]: accessoriesProcessDCDetailsReducer,
    [ACCESSORIES_PROCESS_DC_INWARD_MASTER]: accessoriesProcessDCInwardHeaderReducer,
    [ACCESSORIES_PROCESS_DC_INWARD_DETAILS]: accessoriesProcessDCInwardDetailsReducer,
    [ACCESSORIES_PO]: accessoriesPOReducer,
    [ACCESSORIES_PO_DETAILS]: accessoriesPODetailsReducer,
    [GENERAL_PO_MASTER]: generalPoMasterReducer,
    [GENERAL_PO_DETAILS]: generalPoDetailsReducer,
    [PRINTING_DC_INWARD_MASTER]: printingDcInwardHeaderReducer,
    [PRINTING_DC_INWARD_DETAILS]: printingDcInwardDetailsReducer,
    [CHECKING_DC_MASTER]: checkingDcMasterReducer,
    [CHECKING_DC_DETAILS]: checkingDcDetailsReducer,
    [GENERAL_PO_INWARD_MASTER]: generalPoInwardHeaderReducer,
    [GENERAL_PO_INWARD_DETAILS]: generalPoInwardDetailsReducer,
    [ACCESSORIES_PO_INWARD_MASTER]: accessoriesPoInwardHeaderReducer,
    [ACCESSORIES_PO_INWARD_DETAILS]: accessoriesPoInwardDetailsReducer,
    [CUTTING_DC_INWARD_MASTER]: cuttingDcInwardHeaderReducer,
    [CUTTING_DC_INWARD_DETAILS]: cuttingDcInwardDetailsReducer,
    [GENERAL_DC_MASTER]: generalDcMasterReducer,
    [GENERAL_DC_DETAILS]: generalDcDetailsReducer,
    [GENERAL_DC_INWARD_MASTER]: generalDcInwardHeaderReducer,
    [GENERAL_DC_INWARD_DETAILS]: generalDcInwardDetailsReducer,
    [CHECKING_DC_INWARD_MASTER]: checkingDcInwardHeaderReducer,
    [CHECKING_DC_INWARD_DETAILS]: checkingDcInwardDetailsReducer,
    [IRONING_PACKING_DC]: ironingPackingDcReducer,
    [IRONING_PACKING_DC_DETAILS]: ironingPackingDCDetailsReducer,
    [PRINTING_DC_DETAILS]: printingDCDetailsReducer,
    [PIM]: PimReducer,
    [PIM_DETAILS]: pimDetailsReducer,
    [PIM_ADDITIONAL_EXPENSE]: pimAdditionalExpenseReducer,
    [BILL_PAYMENT_DETAILS]: billPaymentDetailsReducer,
    [BILL_PAYMENT_MASTER]: billPaymentMasterReducer,
    [PROCESS_ASSIGN_STYLE_MASTER]: processAssignStyleMasterReducer,
    [YARN_MASTER]: yarnMasterReducer,
    [FABRIC_MASTER]: fabricMasterReducer,
    [SALES_ORDER_DEMAND]: salesOrderDemandReducer,
    [STYLE_MASTER_MAIN]: styleMasterMainReducer,
    [DESPATCH_DC]: despatchDCReducer,
    [DESPATCH_DC_DETAILS]: despatchDCDetailsReducer,
    [COSTING_HEADER]: costingHeaderReducer,
    [ROUGH_FABRIC_COSTING]: roughFabricCosting,
    [CASH]: cashRequisitionReducer,
    [CASH_REQUISITION_DETAILS]: CashRequisitionDetailsReducer,
    [DIRECT_BILLING]: directBillingReducer,
    [DIRECT_BILLING_DETAILS]: directBillingDetailsReducer,
    [ACCOUNT_PROPERTY]: AccountPropertyReducer,
    [ACCOUNT_PROPERTY_MODAL]: accountPropertyModalReducer,
    [YARN_PROJECTION]: yarnProjectionReducer,
    [FABRIC_PROJECTION]: fabricProjectionReducer,
    [SHIPPING_PLAN]: shippingReducer,
    [SHIPPING_PLAN_DETAILS]: shippingDetailsReducer,
    [PRODUCT_DISPATCH]: productDispatchReducer,
    [PACKING_ENTRY]: packingEntryReducer,
    [PRODUCT_STOCK]: productStockReducer,
    [DYEING_DETAILS]: DyeingDetailsReducer,
    //DK Requirements
    [DASHBOARD_DK]: dashboardDKReducer,
    [REPORT_DK]: reportDKReducer,
    [BILL_ENTRY_REPORT]: billEntryReports,
    [REPORT_STOCK_DK]: reportStockDKReducer,
    [REPORT_STOCK_LEDGER_DK]: reportStockLedgerDKReducer,
    [STOCKWISEREPORTSLEDGER_DK_DETAILS]: stockLedgerDKDetailsReducer,
    [YARN_PO_DK]: yarnPODKReducer,
    [YARN_PO_DK_DETAILS]: yarnPODKDetailsReducer,
    [YARN_INWARD_DK]: yarnInwardDKReducer,
    [YARN_INWARD_DK_DETAILS]: yarnInwardDKDetailsReducer,
    [FABRIC_INWARD_DK]: fabricInwardDKReducer,
    [FABRIC_INWARD_DETAILS_DK]: fabricInwardDKDetailsReducer,
    [GENERAL_INWARD_DK]: generalInwardDKReducer,
    [GENERAL_INWARD_DETAILS_DK]: generalInwardDKDetailsReducer,
    [STYLE_MASTER_BASIC]: styleMasterBasicReducer,
    [SKU_MASTER_HEADER]: skuMasterHeaderReducer,
    [SKU_MASTER_DETAILS]: skuMasterDetailsReducer,
    [KNITTING_INWARD_DK]: knittingInwardDKReducer,
    [KNITTING_INWARD_DETAILS_DK]: knittingInwardDetailsDKReducer,
    [FABRIC_PO_MASTER_DK]: fabricPoMasterDKReducer,
    [FABRIC_PO_DETAILS_DK]: fabricPoDetailsDKReducer,
    [GENERAL_PO_MASTER_DK]: generalPoMasterDKReducer,
    [GENERAL_PO_DETAILS_DK]: generalPoDetailsDKReducer,
    [DYEING_INWARD_DK_MASTER]: dyeingInwardDKHeaderReducer,
    [DYEING_INWARD_DK_DETAILS]: dyeingInwardDKDetailsReducer,
    [PROCESS_DK]: processDKReducer,
    [PROCESS_FLOW_DK]: processFlowDKReducer,
    [PROCESS_ADD_ON_DK]: processAddOnDKReducer,
    [PROCESS_SUPPLIER_DK]: processSupplierDKReducer,
    [PROCESS_ASSIGN_STYLE_MASTER_DK]: processAssignStyleMasterDKReducer,
    [KNITTING_DC_DK]: knittingDCDKReducer,
    [KNITTING_DC_DETAILS_DK]: knittingDCDKDetailsReducer,
    [DYEING_DC_DK]: dyeingDcDKReducer,
    [DYEING_DC_DETAILS_DK]: dyeingDCDetailsDKReducer,
    [GENERAL_DC_DK]: generalDCDKReducer,
    [GENERAL_DC_DETAILS_DK]: generalDCDKDetailsReducer,
    [GENERAL_DC_INWARD_DK]: generalDCInwardDKReducer,
    [GENERAL_DC_INWARD_DETAILS_DK]: generalDCInwardDetailsDKReducer,
    [PRINTING_DC_INWARD_MASTER_DK]: printingDcInwardDKHeaderReducer,
    [PRINTING_DC_INWARD_DETAILS_DK]: printingDcInwardDKDetailsReducer,
    [ACCESSORIES_PO_MASTER_DK]: accessoriesPoMasterDKReducer,
    [ACCESSORIES_PO_DETAILS_DK]: accessoriesPoDetailsDKReducer,
    [ACCESSORIES_INWARD_DK]: accessoriesInwardDKReducer,
    [ACCESSORIES_INWARD_DETAILS_DK]: accessoriesInwardDKDetailsReducer,
    [PRINTING_DC_DK]: printingDcDKReducer,
    [PRINTING_DC2_DK]: printingDc2DKReducer,
    [PRINTING_DC_DETAILS_DK]: printingDCDetailsDKReducer,
    [PRINTING_DC2_DETAILS_DK]: printingDC2DetailsDKReducer,
    [COMPACTING_INWARD_DK]: compactingInwardDKReducer,
    [COMPACTING_INWARD_DETAILS_DK]: compactingInwardDetailsDKReducer,
    [COMPACTING_DC_DK]: compactingDcDKReducer,
    [COMPACTING_DC_DETAILS_DK]: compactingDCDKDetailsReducer,
    [WASHING_DC_DK]: washingDcDKReducer,
    [WASHING_DC_DETAILS_DK]: washingDCDetailsDKReducer,
    [WASHING_INWARD_DK_MASTER]: washingInwardDKHeaderReducer,
    [WASHING_INWARD_DK_DETAILS]: washingInwardDKDetailsReducer,
    [CUTTING_DC_DK]: cuttingDcDKReducer,
    [CUTTING_DC_DETAILS_DK]: cuttingDCDetailsDKReducer,
    [ACCESSORIES_DC_DK]: accessoriesDCDKReducer,
    [ACCESSORIES_DC_DETAILS_DK]: accessoriesDCDKDetailsReducer,
    [IRONING_PACKING_INWARD_DK_MASTER]: ironingPackingInwardDKHeaderReducer,
    [IRONING_PACKING_INWARD_DK_DETAILS]: ironingPackingInwardDKDetailsReducer,
    [STITCHING_DC_DK]: stitchingDcDKReducer,
    [STITCHING_DC_DETAILS_DK]: stitchingDCDetailsDKReducer,
    [CUTTING_INWARD_DK_MASTER]: cuttingInwardDKHeaderReducer,
    [CUTTING_INWARD_DK_DETAILS]: cuttingInwardDKDetailsReducer,
    [PRINTING2_INWARD_DK_MASTER]: printing2InwardDKHeaderReducer,
    [PRINTING2_INWARD_DK_DETAILS]: printing2InwardDKDetailsReducer,
    [STITCHING_INWARD_DK_MASTER]: stitchingInwardDKHeaderReducer,
    [STITCHING_INWARD_DK_DETAILS]: stitchingInwardDKDetailsReducer,
    [IRONING_PACKING_DC_DETAILS_DK]: ironingPackingDCDetailsDKReducer,
    [IRONING_PACKING_DC_DK]: ironingPackingDcDKReducer,
    [ASANAERROR_POINTS]: asanaErrorPointsReducer,
    [Bill_Entries_DK]: billEntriesDKReducer,
    [BILL_ENTRY_REPORTS_ALL]: billEntryReportsAllReducer,
    [CLOSE_BILL_ENTRY]: closebillEntryReducer,
    [EDIT_ENTRIES]: editEntriesReducer,
    [VERIFIED_BILLS]: verifiedBillsReducer,
    [PROGRAM_DISCOUNT]: programDiscountReducer,
    [CONTRACTOR_BILL]: contractorBillEntriesReducer,
    [STYLE_WISE_REPORT]: styleWiseReportsReducer,
    // [PROJECTION_REPORT] : projectionReportsReducer,
    [PRODUCTION_REPORT]: productionReportsReducer,
    [SUPPLIER_WISE_REPORT]: supplierWiseReportsReducer,
    [COMPACTING_REPORT]: compactingReportsReducer,
    [REPORTS_ALL]: reportsAllReducer,
    [VENDOR_MANAGEMENT]: vendorManagementReducer,
    [RN_PENDING]: rnpendinreportReducer,
    [REQUEST_FORM]: requestFormReducer,
    [FABRIC_REPORT]: fabricReportReducer,
    [MOVE_TO_CUTTING]: moveToCuttingReducer,
    [BILL_RECEIVING]: billReceivingReducer,
    [BILL_RECEIVING_REPORT]: billReceivingReportReducer,
    [BILL_RECEIVING_VERIFY]: billReceivingVerifyReducer,
    [ARTICLE_MASTER]: articleMasterReducer,
    [WAREHOUSE_STYLE]: warehouseStyleReducer,
    [WAREHOUSE_STYLE_DETAILS]: warehouseStyleDetailsReducer,

});
export const useSelector = createSelectorHook();
export default reducer;
